import ButtonContainer from '@@viewCommonComponents/forms/ButtonContainer';
import useSouscriptionWaiverStagesForm from './hooks/useSouscriptionWaiverStagesForm';
import { FormProvider } from 'react-hook-form';
import { equals, pathOr, propOr } from 'ramda';
import { PageLayout } from '@@viewCommonComponents/forms/Layouts.jsx';
import { useTabs } from '@@viewCommonComponents/hooks/useTabs.js';
import DiscountsTable from './components/DiscountsTable.jsx';
import { Icon, PageSubtitle, PageTitle, Tabs } from '@fasstech/middle-design-system';
import TabsPagination from '@@viewCommonComponents/TabsPagination.jsx';

const SouscriptionWaiverStagesForm = ({
  getGrantees,
  getOffer,
  getMiddleText,
  getMiddleBoolean,
  viewMode
}) => {
  const { tabs, setTabs, updateVisibility, isButtonDisabled, displayTabsPagination } = useTabs({
    grantees: propOr([], 'beneficiaries', getGrantees),
    getMiddleText,
    filteredViewMode: equals(viewMode, 'CUSTOMER')
  });

  const { form, onSubmit, $onClickPrev, beneficiariesTypes } = useSouscriptionWaiverStagesForm({
    getGrantees,
    getOffer
  });

  return (
    <FormProvider {...form}>
      <form onSubmit={form.handleSubmit(onSubmit)}>
        <PageLayout withFormLayout={false} className={'flex flex-col items-center w-full gap-y-6'}>
          <Icon name={'circleDiscounts'} size={70} />
          <PageTitle>{getMiddleText('CUSTOMER_DISCOUNT_VIEW_TITLE')}</PageTitle>
          <PageSubtitle>{getMiddleText('CUSTOMER_DISCOUNT_VIEW_DESCRIPTION')}</PageSubtitle>
          <div className={'flex flex-col gap-4'}>
            <TabsPagination
              updateVisibility={updateVisibility}
              isButtonDisabled={isButtonDisabled}
              show={displayTabsPagination}
            >
              <Tabs
                items={tabs.tabs}
                selected={tabs.selectedTab}
                onClick={(index) => {
                  setTabs({
                    selectedTab: index,
                    tabs: tabs.tabs
                  });
                }}
                isDisplayed={tabs.tabs.length > 1}
              />
            </TabsPagination>
          </div>
          <DiscountsTable
            pricings={pathOr([], ['offer', 'packs', tabs.selectedTab, 'pricings'], getOffer)}
            beneficiaryIndex={tabs.selectedTab}
            beneficiariesTypes={beneficiariesTypes}
            getMiddleText={getMiddleText}
            getMiddleBoolean={getMiddleBoolean}
          />
        </PageLayout>

        <ButtonContainer
          $onPreviousButtonClick={$onClickPrev}
          nextButtonLabel={getMiddleText('GENERAL_COMMON_TEXTS_NEXT_BUTTON_LABEL')}
          displayResumeButton
          getMiddleText={getMiddleText}
        />
      </form>
    </FormProvider>
  );
};

export default SouscriptionWaiverStagesForm;
